// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__jK2cH","ellipsis":"styles_ellipsis__htzHe","text2AndMoreLines":"styles_text2AndMoreLines__hTcjV","tooltipTrigger":"styles_tooltipTrigger__tMCiV"};